import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import myTrainingProgramActionCreators from '../../store/my-training-program/action-creators';
import TrainingPhaseCard from '../oits/TrainingPhaseCard';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import Modal from '../../../shared/ui/Modal';
import ObservationPhaseDetail from '../training-phases/ObservationPhaseDetail';
import OrientationPhaseDetail from '../training-phases/OrientationPhaseDetail';
import trainingPhasesSelectors from '../../store/training-phases/selectors';
import TasksReport from '../task-groups/TasksReport';
import taskResponsesActionCreators from '../../store/task-responses/action-creators';
import tasksActionCreators from '../../store/tasks/action-creators/tasks';
import taskGroupsActionsCreators from "../../store/task-groups/action-creators/task-groups";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";
import ReportEditSplit from "../reports/ReportEditSplit";

class MyTrainingProgramDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tasksOpened: false,
      trainingPhaseInitialized: false
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  get isLoading() {
    return !this.props.myTrainingProgram && !this.state.trainingPhaseInitialized;
  }

  // ----------------------
  // methods
  // ----------------------

  openTasks(phase) {
    this.setState({
      tasksOpened: phase,
    });
  }

  closeTasks() {
    this.setState({
      tasksOpened: null,
    });
  }

  // ----------------------
  // Computed
  // ----------------------

  componentDidMount() {
    this.props.loadMyTrainingProgram()
      .then(() => {
        this.setState({
          trainingPhaseInitialized: true
        })
      })
      .catch(err => {
        this.setState({
          trainingPhaseInitialized: true
        })
      });
  }

  get selectedPhase() {
    return !this.props.selectedPhaseGuid
      ? null
      : this.props.trainingPhases.find((phase) => {
        return phase.guid === this.props.selectedPhaseGuid;
      });
  }

  get phaseDetailsTitle() {
    return this.selectedPhase && this.selectedPhase.type === 'observation'
      ? `${this.props.myTrainingProgram.getFullName()}: ${
        this.selectedPhase.header
      }`
      : 'Orientation';
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading &&
        this.props.myTrainingProgram ? (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">My Training Program</h4>
              </div>
              <div className="app-content timeline">
                {this.props.trainingPhases &&
                  this.props.trainingPhases.map((phase, index) => (
                    <TrainingPhaseCard
                      key={parseInt(index, 10)}
                      onViewPhase={phaseGuid =>
                        this.props.viewTrainingPhase(phaseGuid)
                      }
                      onViewTasks={(phase) => {
                        return this.openTasks(phase);
                      }}
                      phase={phase}
                    />
                  ))}
              </div>
              <Modal
                isOpen={this.props.selectedTrainingPhaseModal}
                onClose={() => this.props.closeViewPhase()}
                title={this.phaseDetailsTitle}
              >
                {this.selectedPhase &&
                  this.selectedPhase.type === 'observation' && (
                    <ObservationPhaseDetail phase={this.selectedPhase} />
                  )}
                {this.selectedPhase &&
                  this.selectedPhase.type === 'orientation' && (
                    <OrientationPhaseDetail phase={this.selectedPhase} />
                  )}
              </Modal>

              <ModalSplit
                isOpen={this.props.isEditingReportModalOpened}
                onClose={() => this.props.closeEditReport()}
                title={
                  this.props.editingReport && this.props.editingReport.formName
                }
              >
                <ReportEditSplit />
              </ModalSplit>

              <ModalSplit
                isOpen={this.props.isViewingReportModalOpened}
                onClose={() => this.props.closeViewReport()}
                title={this.props.report && this.props.report.formName}
              >
                <ReportViewSplit
                  phase={this.selectedPhase}
                  report={this.props.report}
                />
              </ModalSplit>

              <Modal
                isOpen={!!this.state.tasksOpened}
                onClose={() => this.closeTasks()}
                title="Tasks"
              >
                {this.state.tasksOpened && (
                  <TasksReport
                    oitGuid={this.props.selectedOitGuid}
                    phase={this.state.tasksOpened}
                  />
                )}
              </Modal>
            </Fragment>
        ) : <h3 className="text-center mt-3">Training not Started</h3>}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isAddingReport: state.trainingPhases.isAddingReport,
    isEditingReport: !!state.trainingPhases.isEditingReport,
    isEditingReportModalOpened: state.trainingPhases.isEditingReportModalOpened,
    isViewingReport: !!state.trainingPhases.isViewingReport,
    isViewingReportModalOpened: state.trainingPhases.isViewingReportModalOpened,
    myTrainingProgram: state.myTrainingProgram.oit,
    selectedPhaseGuid: state.trainingPhases.selectedGuid,
    selectedTrainingPhaseModal: state.trainingPhases.selectedTrainingPhaseModal,
    trainingPhases: state.myTrainingProgram.trainingPhases,
    report: trainingPhasesSelectors.viewingReport(state),
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeViewPhase: () => {
      return dispatch(trainingPhasesActionCreators.closeViewTrainingPhase());
    },
    closeAddReport: () => {
      dispatch(trainingPhasesActionCreators.closeAddReport());
    },
    closeEditReport: () => {
      dispatch(trainingPhasesActionCreators.closeEditReport());
    },
    closeViewReport: () => {
      dispatch(trainingPhasesActionCreators.closeViewReport());
    },
    loadMyTrainingProgram: () => {
      return dispatch(myTrainingProgramActionCreators.loadMyTrainingProgram());
    },
    viewTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActionCreators.viewTrainingPhase(phaseGuid));
    },
    loadTasks: () => {
      return dispatch(tasksActionCreators.loadTaskContainer());
    },
    fetchTaskResponsesForUser: (userId) => {
      return dispatch(taskResponsesActionCreators.fetchForUser(userId));
    },
    fetchTaskGroups: () => {
      return dispatch(taskGroupsActionsCreators.fetchTaskGroups());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyTrainingProgramDetail);
